<template>
  <div id="app">
    <message :title="msg.title" :content="msg.content" :status="msg.status"/>
    <navbar/>
    <div id="sidebar-context" class="ui pushable">
      <!-- <sidebar-menu :menu="menu" :collapsed="collapsed" @collapse="onCollapse" /> -->
      <sidebar/>

      <div class="pusher">
        <div class="ui fluid container">
          <div class="ui grid">
            <div class="thirteen wide column">
              <router-view/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showFeeBar" class="footer">
      <div class="ui clearing segment">
        <div
          class="ui right floated button primary"
          :class="{'disabled': publishing}"
          @click="publishFee"
        >
          <template v-if="publishing">Publishing</template>
          <template v-if="!publishing">Publish</template>
        </div>
        <div class="ui right floated button green" @click="addFee">Add Fee</div>
      </div>
    </div>
  </div>
</template>


<script>
import { eventBus } from "@/main.js";
import navbar from "@/components/Navbar.vue";
import message from "@/components/Message.vue";
import sidebar from "@/components/Sidebar.vue";

const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
};

export default {
  name: "app",
  components: {
    navbar,
    message,
    sidebar
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      msg: {
        title: "",
        content: "",
        status: ""
      },
      menu: [
        {
          header: true,
          title: "Admin Dashboard"
        },
        {
          href: "/",
          title: "Dashboard",
          icon: "home icon"
        },
        {
          href: "/contracts",
          title: "Contracts",
          icon: "file alternate icon"
        },
        {
          // href: '/fees',
          title: "Fees",
          icon: "money bill alternate icon",
          child: [
            {
              href: "/fees",
              title: "Contract Fees"
            },
            {
              href: "/acc_fees",
              title: "Account Fees"
            }
          ]
        }
      ],
      showFeeBar: 0,
      publishing: 0
      // collapsed: true
    };
  },
  methods: {
    init() {
      eventBus.$on("statusMessage", objMsg => {
        this.msg.title = objMsg.title;
        this.msg.content = objMsg.content;
        this.msg.status = objMsg.status;
      });
      eventBus.$on("accFeeContext", on => {
        this.showFeeBar = on;
      });
      eventBus.$on("publishStatus", status => {
        this.publishing = status;
      })
    },
    addFee() {
      eventBus.$emit('addFee', 1);
    },
    publishFee() {
      this.publishing = 1;
      eventBus.$emit('publishFee', 1);
    }
  }
};
</script>

<style>
.vue-notification {
  padding: 14px;
  margin: 0 5px 7px 2px;
  font-size: 15px;
  z-index: 5000 !important;

  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;
}
.vue-notification .success {
  background: #68cd86;
  border-left-color: #42a85f;
}
</style>

